import { isNil, isEmpty, size, last, cloneDeep } from 'lodash';
import ServiceUrls from '@/lib/ServiceUrls';
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import $moment from '../lib/util/moment';
import FilterMixin from './FilterMixin';

// define a mixin object
export default {

  mixins: [FilterMixin],

  filters: {
    toDuration: function (val) {
      const duration = $moment.duration($moment.utc().diff($moment.utc(val)));
      if (duration.asMinutes() <= 90) {
        return `${Math.round(duration.asMinutes())} m`;
      } else if (duration.asHours() <= 36) {
        return `${Math.round(duration.asHours())} h`;
      } else if (duration.asDays() <= 31) {
        return `${Math.round(duration.asDays())} d`;
      } else if (duration.asMonths() <= 12) {
        return `${Math.round(duration.asMonths())} M`;
      } else {
        return `${Math.round(duration.asYears())} Y`;
      }
    },
  },

  computed: {
  },

  methods: {
    updateNotifications: function () {
      this.$store.dispatch(
        'notifications/initialiseStore',
        this.axios.get(this.serviceUrls.hotel.notifications(this)),
      );
    },
    markAsRead: function (notificationId) {
      return this.axios.delete(this.serviceUrls.hotel.notification(this, notificationId)).then((response) => {
        this.updateNotifications();
      });
    },
    markAllAsRead: function (notificationId) {
      return this.axios.post(this.serviceUrls.hotel.readAllNotifications(this)).then((response) => {
        this.updateNotifications();
      });
    },
    openEntity: function (entityType, id, notificationId) {
      let readPromise = Promise.resolve();
      if (!this.hasRole('ROLE_SYSADMIN')) {
        readPromise = this.markAsRead(notificationId);
      }

      let target = null;

      if (entityType === 'RoomReservation') {
        target = { name: 'reservation', params: { reservationId: id } };
      } else if (entityType === 'GuestProfile') {
        target = { name: 'guest', params: { guestProfileId: id } };
      } else if (entityType === 'HotelInquiry') {
        target = { name: 'inquiry', params: { inquiryId: id } };
      } else if (entityType === 'PaymentRequest') {
        target = { name: 'paymentRequest', params: { paymentRequestId: id } };
      }

      if (!isNil(target)) {
        if (this.$route.name === target.name) {
          if (isNil(target.params)) {
            this.$router.push(target);
          } else {
            const params = Object.entries(target.params);
            const matchingParams = params.map((param) => {
              if (isNil(this.$route.params)) return false;
              return this.$route.params[param[0]] === param[1];
            }).filter(it => it === true);

            if (matchingParams.length !== params.length) {
              this.$router.push(target);
            }
          }
        } else {
          this.$router.push(target);
        }
      }

      return readPromise;
    },
    preProcessNotificationParams(notificationType, notificationParams) {
      const ret = cloneDeep(notificationParams);
      switch (notificationType) {
        case 'PaymentRequestFailed':
          ret[1] = this.$options.filters.toCurrency(ret[1]);
          ret[3] = this.$t(`PaymentRequestType.${ret[3]}`);
          ret[4] = isNil(ret[4]) ? this.$t('PaymentRequestCancellationReason.Unknown') : this.$t(`PaymentRequestCancellationReason.${ret[4]}`);
          return ret;
        default:
          return ret;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/NotificationMixin.js